import createSelector from "../../utils/reselect";

const reshuffleRequestsStateData = (state) => state.reshuffleRequests || {};

export const reshuffleRequests = createSelector(
  reshuffleRequestsStateData,
  (s) => s.get("reshuffleRequests")
);

export const reshuffleRequestLoading = createSelector(
  reshuffleRequestsStateData,
  (s) => s.get("reshuffleRequestLoading")
);

export const reshuffleRequestPageLoading = createSelector(
  reshuffleRequestsStateData,
  (s) => s.get("pageLoading")
);

export const reshuffleRequestPagination = createSelector(
  reshuffleRequestsStateData,
  (s) => s.get("reshuffleRequestPagination")
);

export const getReshuffleError = createSelector(
  reshuffleRequestsStateData,
  (s) => s.get("error")
);
